import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: false,
  error: null,
  plans: [],
  subscriberList: [],
  subscriberLoading: false,
};

const bullionDepositSlice = createSlice({
  name: "bullionDeposit",
  initialState,
  reducers: {
    createDepositRequest: (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    createDepositSuccess: (state) => {
      state.loading = false;
      state.success = true;
      state.error = null;
    },
    createDepositFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },

    // FETCH
   getDepositRequest: (state, action) => {
  state.loading = true;
  state.error = null;
  state.page = action.payload?.page || 0;
  state.limit = action.payload?.limit || 5;
  state.search = action.payload?.search || '';
},
   getDepositSuccess: (state, action) => {
  state.loading = false;
  state.plans = action.payload.plans;
  state.total = action.payload.total;
},
    getDepositFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    deleteDepositRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteDepositSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      // Remove deleted plan from state
      state.plans = state.plans.filter((plan) => plan._id !== action.payload);
    },
    deleteDepositFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    updateDepositStatusRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateDepositStatusSuccess: (state) => {
      state.loading = false;
      state.success = true;
      state.error = null;
    },
    updateDepositStatusFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },

    getSubscribedListRequest: (state) => {
      state.subscriberLoading = true;
    },
    getSubscribedListSuccess: (state, action) => {
      state.subscriberLoading = false;
      state.subscriberList = action.payload.list;
      state.totalSubscribers = action.payload.total;
    },
    getSubscribedListFailure: (state, action) => {
      state.subscriberLoading = false;
      state.error = action.payload;
    },
    transferBenefitsRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    transferBenefitsSuccess: (state) => {
      state.loading = false;
      state.success = true;
    },
    transferBenefitsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
  },
});

export const {
  createDepositRequest,
  createDepositSuccess,
  createDepositFailure,
  getDepositRequest,
  getDepositSuccess,
  getDepositFailure,
  deleteDepositRequest,
  deleteDepositSuccess,
  deleteDepositFailure,
  updateDepositStatusRequest,
  updateDepositStatusSuccess,
  updateDepositStatusFailure,
  getSubscribedListRequest,
  getSubscribedListSuccess,
  getSubscribedListFailure,
  transferBenefitsRequest,
  transferBenefitsSuccess,
  transferBenefitsFailure,
} = bullionDepositSlice.actions;

export default bullionDepositSlice.reducer;
